(function () {
  const content = document.querySelector(".js-article-content");
  if (!content) return;

  // 記事本文の <div class="js-slides"> の中にある画像だけをスライドショーにする。
  // Qoo は「連続する img を自動でまとめる」方式だが、それを ALAMODE に入れると
  // 既存記事12本の画像がいきなりスライドショーに変わってしまうので、明示指定にした。
  const groups = content.querySelectorAll(".js-slides");
  if (!groups.length) return;

  groups.forEach(build);

  function build(group) {
    const images = Array.from(group.querySelectorAll("img"));
    if (images.length < 2) return;

    const carousel = document.createElement("div");
    carousel.className = "blog-carousel";

    const viewport = document.createElement("div");
    viewport.className = "blog-carousel__viewport";

    const track = document.createElement("div");
    track.className = "blog-carousel__track";

    const prevBtn = document.createElement("button");
    prevBtn.className = "blog-carousel__arrow blog-carousel__prev";
    prevBtn.type = "button";
    prevBtn.setAttribute("aria-label", "前の画像");
    prevBtn.innerHTML = "‹";

    const nextBtn = document.createElement("button");
    nextBtn.className = "blog-carousel__arrow blog-carousel__next";
    nextBtn.type = "button";
    nextBtn.setAttribute("aria-label", "次の画像");
    nextBtn.innerHTML = "›";

    const dotsWrap = document.createElement("div");
    dotsWrap.className = "blog-carousel__nav";

    images.forEach(function (img, index) {
      const slide = document.createElement("div");
      slide.className = "blog-carousel__slide";
      slide.appendChild(img.cloneNode(true));
      track.appendChild(slide);

      const dot = document.createElement("button");
      dot.className = "blog-carousel__dot";
      dot.type = "button";
      dot.dataset.index = index;
      dot.setAttribute("aria-label", index + 1 + "枚目");
      if (index === 0) dot.classList.add("is-active");
      dotsWrap.appendChild(dot);
    });

    viewport.appendChild(track);
    viewport.appendChild(prevBtn);
    viewport.appendChild(nextBtn);
    carousel.appendChild(viewport);
    carousel.appendChild(dotsWrap);

    group.replaceWith(carousel);
    init(carousel);
  }

  function init(carousel) {
    const track = carousel.querySelector(".blog-carousel__track");
    const slides = carousel.querySelectorAll(".blog-carousel__slide");
    const dots = carousel.querySelectorAll(".blog-carousel__dot");
    const prevBtn = carousel.querySelector(".blog-carousel__prev");
    const nextBtn = carousel.querySelector(".blog-carousel__next");

    let index = 0;
    let startX = 0;

    function update() {
      track.style.transform = "translateX(" + -index * 100 + "%)";
      dots.forEach(function (d) { d.classList.remove("is-active"); });
      if (dots[index]) dots[index].classList.add("is-active");
    }

    function next() { index = (index + 1) % slides.length; update(); }
    function prev() { index = (index - 1 + slides.length) % slides.length; update(); }

    nextBtn.addEventListener("click", next);
    prevBtn.addEventListener("click", prev);
    dots.forEach(function (d) {
      d.addEventListener("click", function () { index = Number(d.dataset.index); update(); });
    });

    track.addEventListener("touchstart", function (e) { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener("touchend", function (e) {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) (diff > 0 ? next : prev)();
    });

    carousel.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
    });

    update();
  }
})();
